import type { ReactElement } from 'react';
import { List } from '@noah-labs/fe-shared-ui-components';
import type {
  MarkdownRemarkFrontmatterHeaderMenuHeaderLinks,
  Maybe,
} from '../../../generated/types';
import { LanguageSwitch } from '../i18n/LanguageSwitch';
import { DesktopMenuItem } from './DesktopMenuItem';

export type PpDesktopMenu = {
  menu: Maybe<Maybe<MarkdownRemarkFrontmatterHeaderMenuHeaderLinks>[]> | undefined;
  onEnter: (label: string) => void;
  onLeave: () => void;
  selectedMenu: string;
  withLanguageSwitch?: boolean;
};

export function DesktopMenu({
  menu,
  onEnter,
  onLeave,
  selectedMenu,
  withLanguageSwitch,
}: PpDesktopMenu): ReactElement {
  return (
    <List direction="row" spacing={1} sx={{ alignItems: 'flex-start', justifyContent: 'flex-end' }}>
      {menu?.map((menuItem) => (
        <DesktopMenuItem
          key={menuItem?.headerLabel}
          hasSublinks={menuItem?.headerURL === 'blank'}
          isSelected={menuItem?.headerLabel === selectedMenu}
          menuItem={menuItem}
          onEnter={onEnter}
          onLeave={onLeave}
        />
      ))}
      {withLanguageSwitch && (
        <LanguageSwitch
          isSelected={selectedMenu === 'Locale'}
          onEnter={onEnter}
          onLeave={onLeave}
        />
      )}
    </List>
  );
}
